import { SourceAPI } from '../api/SourceAPI';
import { EntityForm, EntityFormProps } from '../../entity-form/EntityForm';
import { GenericApiResponse } from '../../shared/interfaces/generics';
import {
  EntityDefaultName,
  TemplateRawForm
} from '../../template-form/interfaces/template-raw-form';
import { AsyncTaskResponse } from '../../shared/interfaces/async-task';
import { TemplateFormState } from '../../template-form/interfaces/template-form';

export type SourceSettingsProps = Pick<
  EntityFormProps,
  | 'formImperativeRef'
  | 'isSBSDocsAllowed'
  | 'onComplete'
  | 'formSubmitResolver'
  | 'onStateChange'
  | 'mode'
  | 'topAdornment'
> & {
  formDataResolver: () => Promise<GenericApiResponse<TemplateRawForm>>;
  defaultSourceNameResolver?: (() => Promise<GenericApiResponse<EntityDefaultName>>) | null;
  testConnectionResolver: (
    values: TemplateFormState
  ) => Promise<GenericApiResponse<AsyncTaskResponse>>;
};

export function SourceSettings({
  isSBSDocsAllowed,
  mode,
  formSubmitResolver,
  onComplete,
  formDataResolver,
  formImperativeRef,
  onStateChange,
  testConnectionResolver,
  defaultSourceNameResolver,
  topAdornment
}: SourceSettingsProps) {
  const testConnectionTaskIdResolver = (values: unknown) => {
    return testConnectionResolver(values as TemplateFormState);
  };

  const testConnectionStatusResolver = (taskId: string) => {
    return SourceAPI.getTestConnectionStatus(taskId);
  };

  return (
    <EntityForm
      formDataResolver={formDataResolver}
      formMetaOptionalValueResolvers={{
        entityDefaultName: { resolver: defaultSourceNameResolver, defaultValue: '' }
      }}
      entity='SOURCE'
      mode={mode}
      isSBSDocsAllowed={isSBSDocsAllowed}
      onComplete={onComplete}
      testConnectionTaskIdResolver={testConnectionTaskIdResolver}
      testConnectionResolver={testConnectionStatusResolver}
      formSubmitResolver={formSubmitResolver}
      formImperativeRef={formImperativeRef}
      onStateChange={onStateChange}
      topAdornment={topAdornment}
    />
  );
}
